import apiService from '../apiService'
import { POST } from '../apiService'

const apiPath = '/priceAuto'
const urlTaskbackend = 'https://taskbackend-fin-insurance.com'

export const priceAutoController = (configService) => {
	const service = apiService(configService)
	return {
		getPriceAuto: (params) => {
			return service.post({
				url: `${apiPath}/get_price_auto`,
				body: { ...params },
			})
		},
		getPackageChubb: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/chubb-search-package`,
				body: { ...params, send_from: 'task', api_company_type: 'prod' },
				headers,
			})
		},
		getPackageDvs: (params) => {
			const headers = {
				Authorization: 'admin-task02',
			}
			return POST({
				url: `${urlTaskbackend}/warranty/api/v1/insurance/dj-dvs-search-package`,
				body: { ...params, send_from: 'task', api_company_type: 'prod' },
				headers,
			})
		},
	}
}
